import axios from 'axios';

import constants from '../constants';

const httpAdapter = require('axios/lib/adapters/http');

export const APIInstance = axios.create({
    baseURL: constants.ATHENA_URL,
    headers: {'content-type': 'application/json', accept: 'application/json'},
    ...(constants.IS_E2E_TEST && {adapter: httpAdapter}),
});

export const HostUrlInstanceWithJson = axios.create({
    baseURL: typeof window !== 'undefined' ? `${window.location.origin}/` : 'http://localhost:3000/',
    headers: {'content-type': 'application/json', accept: 'application/json'},
});

export const HostUrlInstanceForUpload = axios.create({
    baseURL: typeof window !== 'undefined' ? `${window.location.origin}/` : 'http://localhost:3000/',
    headers: {'content-type': 'application/octet-stream'},
});

const instances = [APIInstance, HostUrlInstanceWithJson];
const updateInstances = [APIInstance, HostUrlInstanceWithJson];

let requestInterceptors = instances.map((instance) => {
    return instance.interceptors.request.use(
        async (request) => request,
        (error) => Promise.reject(error),
    );
});

export const updateInterceptors = (idToken: string) => {
    requestInterceptors = requestInterceptors.map((interceptor, index) => {
        updateInstances[index].interceptors.request.eject(interceptor);
        return updateInstances[index].interceptors.request.use(
            async (request) => {
                request.headers.Authorization = `Bearer ${idToken}`;
                return request;
            },
            (error) => Promise.reject(error),
        );
    });
};
